// @mui
import { TableRow, TableCell } from '@mui/material';

// ----------------------------------------------------------------------

type Props = {
  height?: number | string;
  emptyRows: number;
};

export default function TableEmptyRows({
  emptyRows,
  height,
}: Props): JSX.Element | null {
  if (!emptyRows) {
    return null;
  }

  const scaledHeight =
    typeof height === 'number'
      ? height * emptyRows
      : height === undefined
      ? undefined
      : `calc(${height} * ${emptyRows})`;

  return (
    <TableRow
      sx={{
        ...(scaledHeight === undefined ? {} : { height: scaledHeight }),
      }}
    >
      <TableCell colSpan={9} />
    </TableRow>
  );
}
